export enum PolicyDeassignEntityType {
  NOMINEE = "NOMINEE",
  MEMBER = "MEMBER",
  ECARD = "ECARD",
}
